// extracted by mini-css-extract-plugin
module.exports = {"grid":"PageMain_grid__JKNN9","col":"PageMain_col__n_w7h","main":"PageMain_main__IjEBp","sidebar":"PageMain_sidebar__jft_i"};